type ScrollLockState = {
  count: number;
  previousOverflow: string;
};

const scrollLocks = new WeakMap<HTMLElement, ScrollLockState>();

export const lockElementScroll = (
  element?: HTMLElement | null,
): (() => void) => {
  if (!element) return () => undefined;

  const existingLock = scrollLocks.get(element);
  if (existingLock) {
    existingLock.count += 1;
  } else {
    scrollLocks.set(element, {
      count: 1,
      previousOverflow: element.style.overflow,
    });
    element.style.overflow = 'hidden';
  }

  let released = false;

  return () => {
    if (released) return;
    released = true;

    const activeLock = scrollLocks.get(element);
    if (!activeLock) return;

    activeLock.count -= 1;
    if (activeLock.count > 0) return;

    element.style.overflow = activeLock.previousOverflow;
    scrollLocks.delete(element);
  };
};
